import isEmpty from 'lodash/isEmpty'
import { useContext } from '../Context'
import { PublicMetadataDisplayContent } from '@ztechapps/product.webui'
import React from 'react'
import { ShowIf } from '@ztechapps/webui.util'

export const Specification = () => {
  const { document } = useContext()

  return (
    <ShowIf condition={!isEmpty(document?.metadata)}>
      <h5 className="title-description mt-3">Specifications</h5>
      <PublicMetadataDisplayContent value={document?.metadata} />
    </ShowIf>
  )
}
